import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, LockIcon, EyeIcon, EyeOffIcon, LoaderIcon } from 'lucide-react';
import Button from '../components/Button';
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Reset error message
    setError('');
    // Set loading state
    setIsLoading(true);
    // Simulate API call with timeout
    setTimeout(() => {
      setIsLoading(false);
      setError('Invalid username and password');
      console.log('Login attempt with:', {
        email,
        password,
        rememberMe
      });
    }, 1500); // Show spinner for 1.5 seconds
  };
  return <div className="min-h-screen flex flex-col md:flex-row bg-cream" data-id="element-438">
      {/* Left column - Image */}
      <div className="hidden md:flex md:w-1/2 bg-burgundy items-center justify-center relative" data-id="element-439">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3rjFKhVBkzGrgZZWs7hjDn/chefchat-login-bg.png" alt="Chef preparing a dish in a professional kitchen" className="w-full h-full object-cover opacity-20" data-id="element-440" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-12" data-id="element-441">
          <h2 className="text-3xl md:text-4xl font-bold text-cream font-display mb-6" data-id="element-442">
            Welcome Back to ChefChat
          </h2>
          <p className="text-lg text-cream max-w-md" data-id="element-443">
            Your AI-powered assistant that helps you manage restaurant
            communications and delight your customers.
          </p>
        </div>
      </div>
      {/* Right column - Login form */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-8" data-id="element-444">
        <div className="w-full max-w-md" data-id="element-445">
          <div className="text-center mb-8" data-id="element-446">
            <Link to="/" className="inline-block" data-id="element-447">
              <span className="text-burgundy font-display text-3xl font-bold" data-id="element-448">
                Chef<span className="text-sage" data-id="element-449">Chat</span>
              </span>
            </Link>
            <h1 className="mt-6 text-2xl font-bold text-charcoal" data-id="element-450">
              Sign in to your account
            </h1>
            <p className="mt-2 text-sage" data-id="element-451">
              Enter your credentials to access your dashboard
            </p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-452">
            {error && <div className="p-3 bg-red-50 border border-red-200 text-red-700 rounded-md text-sm" data-id="element-453">
                {error}
              </div>}
            <div data-id="element-454">
              <label htmlFor="email" className="block text-sm font-medium text-charcoal mb-1" data-id="element-455">
                Email Address
              </label>
              <div className="relative" data-id="element-456">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-457">
                  <MailIcon size={18} className="text-sage" data-id="element-458" />
                </div>
                <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-sage/30 rounded-md shadow-sm focus:ring-burgundy focus:border-burgundy" placeholder="your@email.com" data-id="element-459" />
              </div>
            </div>
            <div data-id="element-460">
              <label htmlFor="password" className="block text-sm font-medium text-charcoal mb-1" data-id="element-461">
                Password
              </label>
              <div className="relative" data-id="element-462">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-463">
                  <LockIcon size={18} className="text-sage" data-id="element-464" />
                </div>
                <input id="password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="block w-full pl-10 pr-10 py-2 border border-sage/30 rounded-md shadow-sm focus:ring-burgundy focus:border-burgundy" placeholder="••••••••" data-id="element-465" />
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-466">
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="text-sage hover:text-burgundy focus:outline-none" data-id="element-467">
                    {showPassword ? <EyeOffIcon size={18} data-id="element-468" /> : <EyeIcon size={18} data-id="element-469" />}
                  </button>
                </div>
              </div>
            </div>
            <div className="flex items-center" data-id="element-470">
              <input id="remember-me" name="remember-me" type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} className="h-4 w-4 text-burgundy focus:ring-burgundy border-gray-300 rounded" data-id="element-471" />
              <label htmlFor="remember-me" className="ml-2 block text-sm text-charcoal" data-id="element-472">
                Remember me
              </label>
            </div>
            <div data-id="element-473">
              <Button className="w-full" disabled={isLoading} data-id="element-474">
                {isLoading ? <span className="flex items-center justify-center" data-id="element-475">
                    <LoaderIcon size={18} className="animate-spin mr-2" data-id="element-476" />
                    Signing in...
                  </span> : 'Sign in'}
              </Button>
            </div>
          </form>
          <div className="mt-8 text-center" data-id="element-477">
            <p className="text-sm text-sage" data-id="element-478">
              Don't have an account?{' '}
              <Link to="/signup" className="font-medium text-burgundy hover:text-burgundy/80" data-id="element-479">
                Start your free trial
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default Login;